import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import Root from "@containers/Root";
import reportWebVitals from "./reportWebVitals";
import {GoogleReCaptchaProvider} from "react-google-recaptcha-v3";

ReactDOM.render(
  <React.StrictMode>
    <GoogleReCaptchaProvider
      reCaptchaKey="6LeAd-IeAAAAAB8berN0QB1pE_i49fabrOaKnEVe"
      language="pt-BR"
    >
      <Root />
    </GoogleReCaptchaProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
